export default {
  namespaced: true,
  state: {
    deviceList: []
  },
  mutations: {
    // 初始化套餐到期相关数据
    setDeviceList(state, devicelist) {
      state.deviceList = devicelist
    }
  }
}
